import { ProductType } from "@obg/core.config";

export const RECOMMENDED_GAMES_COLLECTION_IDS: RecommendedGamesCollectionIds = {
	[ProductType.Casino]: "RecommendedGamesCasino",
	[ProductType.LiveCasino]: "RecommendedGamesLiveCasino",
	[ProductType.Jackpots]: "RecommendedGamesJackpots",
};

type RecommendedGamesCollectionIds = {
	[K in ProductType]?: string;
};
